import React from 'react'
import {FormattedMessage} from 'react-intl'
import {
    Flex,
    Text,
    Button,
    SimpleGrid,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import ProductRegistrationCard from '../../product-registration/partials/product-registration-card'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import GuaranteedIcon from '../../../components/icons/support/GuaranteedIcon'
import SupportIcon from '../../../components/icons/support/SupportIcon'
import DiscountIcon from '../../../components/icons/action/DiscountIcon'
import ManualsIcon from '../../../components/icons/others/ManualsIcon'
import routingObject from '../../../utils/static-routes'

const cardsData = [
    {
        icon: GuaranteedIcon,
        description: (
            <FormattedMessage
                id="product_registration.guaranteedIcon_description"
                defaultMessage="Extended warranty on selected items. Check <u>eligible products</u>"
                values={{
                    u: (chunks) => <u>{chunks}</u>,
                }}
            />
        ),
    },
    {
        icon: ManualsIcon,
        description: (
            <FormattedMessage
                id="product_registration.icon360_description"
                defaultMessage="Easy access to your product information and helpful tips"
            />
        ),
    },
    {
        icon: DiscountIcon,
        description: (
            <FormattedMessage
                id="product_registration.discountIcon_description"
                defaultMessage="Exclusive offers with newsletter sign up"
            />
        ),
    },
    {
        icon: SupportIcon,
        description: (
            <FormattedMessage
                id="product_registration.supportIcon_description"
                defaultMessage="Direct access to our dedicated product service and support teams"
            />
        ),
    },
]

const RegisteredProductWidget = () => {
    const styles = useMultiStyleConfig('Account')
    const navigate = useNavigation()

    const handleButtonClick = () => {
        navigate(routingObject.PRODUCT_REGISTRATION_PATH)
    }
    return (
        <Flex {...styles.productRegistrationBox}>
            <Flex direction="column" gap={6}>
                <Text {...styles.description}>
                    <FormattedMessage
                        id="product_registration.registered_product_widget.why_register"
                        defaultMessage="Why register your product? Get useful tips on how to keep it working at its best
                    throughout its lifetime and gain access to the latest news and exclusive offers."
                    />
                </Text>
                <Button {...styles.registerButton} onClick={handleButtonClick} variant="primary">
                    <FormattedMessage
                        id="product_registration.button"
                        defaultMessage="Register your product now"
                    />
                </Button>
            </Flex>
            <Flex direction="column" gap={6}>
                <Text {...styles.moreBenefits}>
                    <FormattedMessage
                        id="product_registration.registered_product_widget.more_benefits"
                        defaultMessage="More benefits"
                    />
                </Text>
                <SimpleGrid {...styles.cardGrid}>
                    {cardsData.map((card, index) => (
                        <ProductRegistrationCard
                            key={index}
                            icon={card.icon}
                            description={card.description}
                            variant="account-product-registration"
                        />
                    ))}
                </SimpleGrid>
            </Flex>
        </Flex>
    )
}

export default RegisteredProductWidget
